import { render, staticRenderFns } from "./CustomContentRenderer.vue?vue&type=template&id=8e049e9e&scoped=true"
import script from "./CustomContentRenderer.vue?vue&type=script&lang=js"
export * from "./CustomContentRenderer.vue?vue&type=script&lang=js"
import style0 from "./CustomContentRenderer.vue?vue&type=style&index=0&id=8e049e9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e049e9e",
  null
  
)

export default component.exports